import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import React, { useMemo } from 'react';
import { SnakyChartPropType } from './types';

const Snaky = (props: SnakyChartPropType) => {
  const { formater, data, links, header } = props;

  const DEFAULT_STYLE = {
    height: 380,
  };

  const option: EChartsOption = useMemo(() => {
    return {
      series: {
        type: 'sankey',
        layout: 'none',
        emphasis: {
          focus: 'adjacency',
        },
        label: {
          show: true,
          formatter: (params: any) => {
            return `${params.name}\n(${formater[params.name] || 0})`;
          },
        },
        data: data,
        links: links,
        orient: 'horizontal',
        nodeAlign: 'left',
        layoutIterations: 128,
        nodeHeight: 30,
        nodeGap: 30,
        lineSpacing: 10,
      },
    };
  }, [formater, data, links]);

  return (
    <div style={{ width: '100%' }}>
      {header}
      <ReactECharts option={option} style={DEFAULT_STYLE} />
    </div>
  );
};

export default React.memo(Snaky);
